import { render, staticRenderFns } from "./btnCard.vue?vue&type=template&id=842b0e88&lang=pug&"
import script from "./btnCard.vue?vue&type=script&lang=js&"
export * from "./btnCard.vue?vue&type=script&lang=js&"
import style0 from "./btnCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports